import {Component, DestroyRef, HostListener, inject, OnInit, signal} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UiToolsService} from '../../core/ui-tools.service';
import {OperationContainer} from '../../core/definitions/operation-container';
import {OperationStepExecutionResult} from '../../core/definitions/operation-step-execution-result';
import {TranslateService} from '@ngx-translate/core';
import {CmsErrorHandlerService} from '../../core/cms-error-handler.service';
import {lockPageScroll} from './lock-page-scroll';

export interface OperationViewDialogData {
  operationContainer: OperationContainer;
}

@Component({
    selector: 'app-operation-view-dialog',
    templateUrl: './operation-view-dialog.component.html',
    styleUrls: ['./operation-view-dialog.component.scss'],
    standalone: false
})
export class OperationViewDialogComponent implements OnInit {
  // Injections
  public data: OperationViewDialogData = inject(MAT_DIALOG_DATA);
  public dialogRef: MatDialogRef<OperationViewDialogComponent> = inject(MatDialogRef);
  private readonly cmsErrorHandlerService: CmsErrorHandlerService = inject(CmsErrorHandlerService);
  private readonly translate: TranslateService = inject(TranslateService);
  private readonly uiTools: UiToolsService = inject(UiToolsService);
  private readonly document: Document = inject(DOCUMENT);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  operationContainer: OperationContainer;
  operationStepExecutionResult: OperationStepExecutionResult;
  errorMessages: string[] = [];

  hasObjectsInPackage = signal(false);


  @HostListener('click', ['$event.target'])
  registerClick(event: EventTarget) {
    this.uiTools.registerDocumentClick(event);
  }

  ngOnInit(): void {
    this.destroyRef.onDestroy(lockPageScroll(this.document));
    this.operationContainer = this.data.operationContainer;
    if (this.operationContainer.currentOperation) {
      this.operationContainer.currentOperation.$$operationDialog = this.dialogRef;
    }

    for (const object of this.operationContainer.operationContextObjects || []) {
      if ((!!object['package_placement.package_id'] || (object['package_placement']?.['package_id'])) &&
          (this.operationContainer.currentOperation?.operation_type_id === "4e4f4a79-ec65-4f92-b48f-a7c6ef653d3d" ||
           this.operationContainer.currentOperation?.operation_type_id === "0a67a69d-285e-4237-9d9d-5dc7bf2f04e9" ||
           this.operationContainer.currentOperation?.operation_type_id === "26a39f03-fc5f-4915-89cb-7b119cf9e7e0" ||
           this.operationContainer.currentOperation?.operation_type_id === "755488be-e2a2-497f-925c-e0f53c98bd02")) {
        this.hasObjectsInPackage.set(true);
        break;
      }
    }
  }

  onOperationStepExecutionResult(operationStepExecutionResult: OperationStepExecutionResult) {
    this.errorMessages = [];
    if (operationStepExecutionResult) {
      this.errorMessages = this.cmsErrorHandlerService.formatSaveError(
        operationStepExecutionResult.result_object,
        operationStepExecutionResult.status_message,
        operationStepExecutionResult.error_message
      );
    }
    this.operationStepExecutionResult = operationStepExecutionResult;
  }

  get dialogTitle() {
    const title = this.operationContainer.currentOperation.$$currentStep?.information?.title ||
      this.operationContainer.currentOperation.menu_title;
    return this.translate.instant(title);
  }

}
